import { sva } from "@agapi/ui/panda/css";
export const breadcrumbStyles = sva({
    slots: ["nav", "list", "item", "indicator", "label"],
    base: {
        nav: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            color: 'text.subdued'
        },
        list: {
            display: 'flex',
            alignItems: 'center',
            gap: "2",
        },
        item: {
            display: "flex",
            height: '100%',
            fontSize: "sm",
            justifyContent: "center",
            gap: "1",
            alignItems: "center",
            '&:nth-last-child(2) .label': {
                display: { base: "flex" },
                smDown: {
                    ml: '-2'
                }
            },
            '&:first-child .label': {
                smDown: {
                    ml: '0!'
                }
            },
            '&:only-child .label': {
                smDown: {
                    display: 'flex!',
                }
            }
        },
        indicator: {
            display: { base: "none", sm: "flex" },
        },
        label: {
            display: { base: "none", sm: "flex" },
        }
    },
    variants: {
        first: {
            true: {
                indicator: {
                    display: { base: 'flex' }
                }
            }
        }
    }
});
